(function () {
  const container = document.querySelector('.package-selector-container');
  if (!container) return;

  const hasColor = container.querySelector('.color-swatch') !== null;
  const hasPower = container.querySelector('.power-btn') !== null;
  const hasShip = container.querySelector('.ship-btn') !== null;

  let selectedColor = container.querySelector('.color-swatch.is-active')?.dataset.color || '';
  let selectedPower = container.querySelector('.power-btn.is-active')?.dataset.power || '';
  let selectedShip = container.querySelector('.ship-btn.is-active')?.dataset.ship || '';

  const productJson = document.querySelector('#bundle-selector-product-json');
  let variantMap = {};
  if (productJson) {
    try {
      const data = JSON.parse(productJson.textContent);
      (data.variants || []).forEach(v => { variantMap[v.id] = v; });
    } catch(e) {}
  }

  function dispatchVariantChange(variantId) {
    const variant = variantMap[parseInt(variantId)];
    if (!variant) return;

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const allRadios = variantSelects.querySelectorAll('input[type="radio"]');
    const optionNames = [...new Set(Array.from(allRadios).map(r => r.name))];

    variant.options.forEach((optionValue, index) => {
      const name = optionNames[index];
      if (!name) return;
      const radio = variantSelects.querySelector(
        `input[name="${name}"][value="${optionValue}"]`
      );
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function filterPackages() {
    const cards = container.querySelectorAll('.package-selector__variant-group');
    let firstVisible = null;

    cards.forEach(card => {
      const colorMatch = !hasColor || card.dataset.color === selectedColor;
      const powerMatch = !hasPower || card.dataset.power === selectedPower;
      const shipMatch = !hasShip || card.dataset.ship === selectedShip;
      const show = colorMatch && powerMatch && shipMatch;

      card.style.display = show ? '' : 'none';
      if (show && !firstVisible) firstVisible = card;
    });

    if (firstVisible) {
      const radio = firstVisible.querySelector('.package-selector__radio-input');
      if (radio && !container.querySelector('.package-selector__radio-input:checked')) {
        radio.checked = true;
      }
    }

    const checkedRadio = container.querySelector('.package-selector__radio-input:checked');
    if (checkedRadio) {
      dispatchVariantChange(checkedRadio.value);
    }
  }

  container.querySelectorAll('.package-selector__radio-input').forEach(radio => {
    radio.addEventListener('change', () => {
      dispatchVariantChange(radio.value);
    });
  });

  container.querySelectorAll('.color-swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      container.querySelectorAll('.color-swatch').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      selectedColor = btn.dataset.color;
      filterPackages();
    });
  });

  container.querySelectorAll('.power-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      container.querySelectorAll('.power-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      selectedPower = btn.dataset.power;
      filterPackages();
    });
  });

  container.querySelectorAll('.ship-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      container.querySelectorAll('.ship-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      selectedShip = btn.dataset.ship;
      filterPackages();
    });
  });

  filterPackages();
})();
